import { render } from "./Create.vue?vue&type=template&id=79f1a721&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=79f1a721&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=79f1a721&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f1a721"]])

export default __exports__